/**
 * Mock-Daten für die Users-View.
 * Spec: lmm-wiki/wiki/orbit-specs/user-crud-admin.md
 */

const NAMES = [
  ['Erika', 'Mustermann'],
  ['Hans', 'Schmidt'],
  ['Maria', 'García'],
  ['Liam', 'O\'Connor'],
  ['Yuki', 'Tanaka'],
  ['Aleksandr', 'Petrov'],
  ['Fatima', 'al-Hassan'],
  ['Olu', 'Adebayo'],
  ['Sofía', 'Hernández'],
  ['Pieter', 'van der Berg'],
  ['Anneliese', 'Weiß'],
  ['Tobias', 'Krüger'],
  ['Lukas', 'Hofer'],
  ['Camille', 'Dubois'],
  ['Diego', 'Romero'],
];

const ROLES = ['customer', 'customer', 'customer', 'customer', 'staff', 'admin'];
const STATUSES = ['active', 'active', 'active', 'active', 'suspended', 'deleted'];

function pad(n, w = 8) {
  return String(n).padStart(w, '0');
}

/**
 * @param {{ search?: string, status?: string, limit?: number }} [opts]
 * @returns {{ users: Array, total: number }}
 */
export function usersFixture({ search = '', status = '', limit = 50 } = {}) {
  const now = Date.now();
  const all = NAMES.flatMap((fullName, i) => {
    const generationFactor = i * 4;
    return Array.from({ length: 4 }, (_, j) => {
      const id = 4711 + generationFactor + j;
      const role = ROLES[(i + j) % ROLES.length];
      const stat = STATUSES[(i * 2 + j) % STATUSES.length];
      const [first, last] = fullName;
      const email = `${first.toLowerCase().replace(/[^a-z]/g, '')}.${last
        .toLowerCase()
        .replace(/[^a-z]/g, '')}+${j}@example.com`;
      return {
        id,
        customerNumber: `VTY-${pad(id)}`,
        email,
        displayName: `${first} ${last}`,
        role,
        status: stat,
        accountType: i % 3 === 0 ? 'business' : 'private',
        companyName: i % 3 === 0 ? `${last} GmbH` : null,
        vatId: i % 3 === 0 ? `DE${pad(123_000_000 + id, 9)}` : null,
        mfaEnabled: (i + j) % 2 === 0,
        emailVerified: stat !== 'deleted',
        createdAt: new Date(now - (10 + i * 3 + j) * 86_400_000).toISOString(),
        lastLoginAt:
          stat === 'active'
            ? new Date(now - ((i + j) * 60_000 + 5 * 60_000)).toISOString()
            : null,
      };
    });
  });

  const filtered = all.filter((u) => {
    if (search) {
      const q = search.toLowerCase();
      if (
        !u.email.toLowerCase().includes(q) &&
        !u.displayName.toLowerCase().includes(q) &&
        !u.customerNumber.toLowerCase().includes(q)
      ) {
        return false;
      }
    }
    if (status && status !== 'all' && u.status !== status) return false;
    return true;
  });

  return {
    users: filtered.slice(0, limit),
    total: filtered.length,
  };
}

/** @returns {Object | null} */
export function userDetailFixture(userId) {
  const { users } = usersFixture({ limit: 9999 });
  const u = users.find((x) => x.id === Number(userId));
  if (!u) return null;
  return {
    user: {
      ...u,
      billingCountry: u.accountType === 'business' ? 'DE' : null,
      billingCity: u.accountType === 'business' ? 'München' : null,
      billingZip: u.accountType === 'business' ? '80331' : null,
      billingStreet: u.accountType === 'business' ? 'Marienplatz 1' : null,
    },
  };
}

export function userTenantsFixture(userId) {
  // Operator-Memberships für JIT-Provisioning-Demo
  const idNum = Number(userId);
  if (!idNum) return { tenants: [] };
  // Operator-Roles (staff/admin) haben Tenants; Customers nicht
  const { users } = usersFixture({ limit: 9999 });
  const u = users.find((x) => x.id === idNum);
  if (!u || u.role === 'customer') return { tenants: [] };
  return {
    tenants: [
      { id: 1, slug: 'valitype', brandOrigin: 'valitype.com', displayName: 'Valitype', isActive: true },
      ...(idNum % 2 === 0
        ? [{ id: 3, slug: 'valikey', brandOrigin: 'valikey.app', displayName: 'ValiKey', isActive: true }]
        : []),
    ],
  };
}
